<template>
  <div class="horario-tooltip" v-if="tooltip" :style="{ top: tooltip.top + 'px', left: tooltip.left + 'px' }">
    <span class="tooltip-titulo">{{ $t('horarios_atualizacao') }}</span>
    <div v-for="horario in tooltip.horarios" :key="horario.nr_sequencial" class="tooltip-item">
      {{ horario.ds_horario }}
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'HorarioTooltip',
  computed: {
    tooltip() {
      return this.$store.getters['ui/tooltipHorario']
    }
  }
}
</script>

<style scoped>
.horario-tooltip {
  position: fixed;
  z-index: 100000;
  background: var(--rd-bg-2);
  border: 1px solid var(--rd-border-strong);
  border-radius: var(--rd-radius-sm);
  padding: 8px 12px;
  white-space: nowrap;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  text-align: left;
  pointer-events: none;
}

.tooltip-titulo {
  display: block;
  color: var(--rd-text-2);
  font-size: 11px;
  font-weight: 500;
}

.tooltip-item {
  font-size: 12px;
  color: var(--rd-text-1);
  margin-top: 4px;
}
</style>
